<script lang="ts">
  import { onMount } from "svelte";
  import { push } from "svelte-spa-router";
  import { auth } from "$lib/auth";
  import { homePath } from "$lib/surfaces";

  onMount(() => {
    /* When this route is reached by in-app navigation the session is already
       loaded, so subscribe() runs the callback synchronously — the unsubscribe
       handle does not exist yet at that point. Unsubscribing on destroy (the
       push below destroys this component) keeps the callback free of it; the
       flag stops a later store update from routing a second time. */
    let routed = false;
    return auth.subscribe((s) => {
      if (s.loading || routed) return;
      routed = true;
      if (s.authenticated && s.activeTenantSlug) {
        // First login after signup → finish onboarding before the dashboard.
        if (!s.user?.onboarding_completed_at) {
          push(`/t/${s.activeTenantSlug}/onboarding`);
        } else {
          push(homePath(s, s.activeTenantSlug));
        }
      } else if (s.authenticated && s.user?.is_staff) {
        // A membership-less operator is signed in, not signed out: send them
        // to the console instead of bouncing them back to the login form.
        push("/backoffice");
      } else if (s.authenticated) {
        push("/no-tenant");
      } else {
        push("/login");
      }
    });
  });
</script>

<div class="boot-splash">
  <img src="/logo.svg" alt="Order Evolution" class="boot-logo" />
</div>

<style>
  .boot-splash {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--color-bg);
  }
  .boot-logo { height: 48px; width: auto; opacity: 0.5; }
</style>
